// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list.js';

export const resetFacets = () => ({
    type: actions.RESET_TCSM_AUDIT_CLAIM_FACETS
});

export const updateReimbursementRangeDollars = range => ({
    property: 'reimbursedAmount',
    range,
    type: actions.UPDATE_TCSM_AUDIT_CLAIM_REIMBURSEMENT_RANGE_DOLLARS
});

export const updateReimbursementRangePercent = range => ({
    property: 'reimbursedPercentage',
    range,
    type: actions.UPDATE_TCSM_AUDIT_CLAIM_REIMBURSEMENT_RANGE_PERCENT
});

export const updateClaimTypeSelection = (item, isSelected) => ({
    isSelected,
    item,
    type: actions.UPDATE_TCSM_AUDIT_CLAIM_CLAIM_TYPE_SELECTED
});

export const toggleClaimTypes = claimTypes => ({
    claimTypes,
    type: actions.UPDATE_TCSM_AUDIT_CLAIM_CLAIM_TYPE_TOGGLED
});

export const updateDateIssued = dateRange => ({
    property: 'dateIssued',
    range: dateRange,
    type: actions.UPDATE_TCSM_AUDIT_CLAIM_DATE_ISSUED
});

export const showReimbursedAmount = () => ({
    type: actions.TOGGLE_TCSM_AUDIT_CLAIM_REIMBURSED_AMOUNT
});

export const showReimbursedPercent = () => ({
    type: actions.TOGGLE_TCSM_AUDIT_CLAIM_REIMBURSED_PERCENT
});

export const updateSelectedProductCode = productCode => ({
    productCode,
    type: actions.UPDATE_TCSM_AUDIT_CLAIM_PRODUCT_HIERARCHY_SELECTED
});



// WEBPACK FOOTER //
// ./src/tcsm/claim-search/action-creators/facets.js